@if (loading) {
  <app-loader></app-loader>
}

<div class="row">
  <div class="col-xs-12">
    <p-table
      [value]="users"
      [lazy]="true"
      [totalRecords]="totalRecords"
      [paginator]="true"
      (onLazyLoad)="loadUsers($event)"
      [rows]="rows"
      [first]="first"
      [showCurrentPageReport]="true"
      selectionMode="single"
      [(selection)]="selectedUser"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="(null)"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="pageChange($event)"
      [rowsPerPageOptions]="[10, 25, 50]"
      stateStorage="session"
      stateKey="state-session-users-admins"
      >
      <ng-template pTemplate="header">
        <tr>
          @for (key of keys; track key) {
            <th
              pSortableColumn="{{ key }}"
              [style.width]="tableConfig.columns[key].width"
              >
              {{ tableConfig.columns[key].title }}
              <p-sortIcon field="{{ key }}"></p-sortIcon>
            </th>
          }
        </tr>
        <tr>
          <th style="width: 10%">
            <p-columnFilter
              type="text"
              field="first_name"
              [placeholder]="placeholders['first_name']"
              ariaLabel="Filter first_name"
              [showMenu]="false"
              [showClearButton]="false"
              />
          </th>
          <th style="width: 10%">
            <p-columnFilter
              type="text"
              field="last_name"
              [placeholder]="placeholders['last_name']"
              ariaLabel="Filter last_name"
              [showMenu]="false"
              [showClearButton]="false"
              />
          </th>
          <th style="width: 10%">
            <p-columnFilter
              type="text"
              field="email"
              [placeholder]="placeholders['email']"
              ariaLabel="Filter email"
              [showMenu]="false"
              [showClearButton]="false"
              />
          </th>
          <th>
            <p-select
              [ngModel]="selectedIsConfirmed"
              [placeholder]="placeholders['confirmed_at']"
              [options]="confirmedList"
              optionLabel="title"
              [showClear]="true"
              (onChange)="pageChange($event, 'confirmed_at')"
              >
            </p-select>
          </th>
          <th>
            <p-select
              [ngModel]="selectedIsActive"
              [placeholder]="placeholders['active']"
              [options]="activeList"
              optionLabel="title"
              [showClear]="true"
              (onChange)="pageChange($event, 'active')"
              >
            </p-select>
          </th>
          <th>
            <p-select
              [ngModel]="selectedMonth"
              [placeholder]="placeholders['created_at']"
              [options]="monthList"
              optionLabel="title"
              [showClear]="true"
              (onChange)="pageChange($event, 'created_at')"
              >
            </p-select>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr [pSelectableRow]="user">
          @for (key of keys; track key) {
            <td>{{ user[key] }}</td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
